import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { R1DashboardProvider } from "@/features/R1Dashboard/context/R1DashboardProvider";
import IssuersView from "@/features/R1Dashboard/views/IssuersView";

export default function R1Issuers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Issuers");
  }, []);

  return (
    <R1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <IssuersView />
      </main>
    </R1DashboardProvider>
  );
}
